import React from "react";
import PropTypes from "prop-types";
import StoreIconGold from "BSM/assets/StoreIconGold.png";
import styles from "./PanelHeader.module.css";

/**
 * Shared header for the BSM panels (Store, Order Management, Statistics,
 * Settings). Renders the gold store icon, a title, and a dashed underline that
 * bleeds to the surrounding card's borders.
 *
 * @param {string} title    The heading text.
 * @param {React.ReactNode} [actions]  Optional right-aligned content.
 */
export default function PanelHeader({ title, actions }) {
  return (
    <div className={styles.header}>
      <img src={StoreIconGold} alt="" className={styles.icon} />
      <span className={styles.title}>{title}</span>
      {actions != null && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

PanelHeader.propTypes = {
  title: PropTypes.node.isRequired,
  actions: PropTypes.node,
};
